import { render, staticRenderFns } from "./AddProcessM.vue?vue&type=template&id=084d7843&"
import script from "./AddProcessM.vue?vue&type=script&lang=js&"
export * from "./AddProcessM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports